import React from 'react';
import {makeStyles} from '@material-ui/core';
import useLocalization from '../../../../../../hooks/useLocalization';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
    noDataWrapper: {
        background: theme.palette.background.paper,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: theme.spacing(27),
        gridArea: 'game-xp-footer',
        alignSelf: 'self-start',
        margin: `${theme.spacing(8)}px 0px`,
        padding: theme.spacing(2)
    },
    noDataHeading: {
        color: theme.palette.text.primary
    },
    noDataSubHeading: {
        color: theme.palette.text.secondary
    },
    noDataText: {
        textAlign: 'center',
        fontSize: theme.typography.pxToRem(22),
        lineHeight: theme.typography.pxToRem(30),
        letterSpacing: '-0.4px'
    }
}));

const CODES = {
    noDeviceText: 'epic.affiliate.fortnite_games.xp.activations_list.no_devices',
    noDataText: 'epic.affiliate.fortnite_games.xp.activations_list.no_data'
};

const ActivationsPanelNoData = () => {
    const styles = useStyles();
    const getMessage = useLocalization();

    return (
        <Box className={styles.noDataWrapper}>
            <Typography component="h2" className={`${styles.noDataHeading} ${styles.noDataText}`}>
                {getMessage(`${CODES.noDeviceText}`)}
            </Typography>
            <Typography component="p" className={`${styles.noDataSubHeading} ${styles.noDataText}`}>
                {getMessage(`${CODES.noDataText}`)}
            </Typography>
        </Box>
    );
};

export default ActivationsPanelNoData;
